import { GridColumnConfig } from '../../../../models/gridCoumnConfig';

export const WorkOrderLogColumns: GridColumnConfig[] = [
  {
    title: 'Action',
    field: 'message',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Initiated On',
    field: 'createdOn',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Initiated By',
    field: 'initiatedByFullName',
    filter: 'text',
    searchable: true,
  },
];
